import { Component, OnInit } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';
import { checkObjectEquals } from 'gung-common';
import { GungConfiguration, ConfigurationsService } from '../../../services/configurations.service';

@Component({
    selector: 'lib-gung-settings-fortnox-offer-confirmation',
    templateUrl: './gung-settings-fortnox-offer-confirmation.component.html',
    styleUrl: './gung-settings-fortnox-offer-confirmation.component.scss',
    standalone: false
})
export class GungSettingsFortnoxOfferConfirmationComponent extends GungSettingsBaseViewComponent implements OnInit {
  public loading = true;
  public configuration: GungConfiguration;
  constructor(protected configurationsService: ConfigurationsService) {
    super();
  }

  ngOnInit(): void {
    this.configurationsService.getConfigurationsByIds(['FortnoxOfferConfirmationConfig'], true).subscribe(configs => {
      if (!configs || configs.length === 0) {
        return;
      }
      this.configuration = structuredClone(configs[0]);
      this.loading = false;
    });
  }

  public typeOf(variable: any): string {
    return typeof variable;
  }

  public save() {
    this.configurationsService.updateConfiguration(this.configuration).subscribe(_ => {});
  }
}
